/* Brothers in Watches: Watch Finder.
   Reads two pools: the shop's in-stock pieces (JSON emitted by
   sections/bw-finder.liquid) and the reference catalogue in
   bw-finder-data.js. Asks one question at a time, scores every watch, and
   keeps the answers in the URL hash so a result can be shared. */
(function () {
  'use strict';
  window.BW_FINDER = 14;

  var root = document.querySelector('[data-bw-finder]');
  if (!root) return;

  /* ------------------------------------------------------------------ data */

  var STYLE_WORDS = [
    ['diver', /seamaster|submariner|diver|aquaracer|fifty fathoms|black bay|skx|prospex|planet ocean|hydroconquest|aquatimer|\bdive\b|300m|200m|tauchuhr/i],
    ['chrono', /chrono|speedmaster|carrera|daytona|monaco|autavia|el primero|flyback|bundeswehr|navitimer/i],
    ['pilot', /pilot|flieger|mark x|big pilot|avenger|aviator|khaki aviation/i],
    ['field', /khaki field|field|military|\bw10\b|explorer|alpinist/i],
    ['sport', /\bprx\b|royal oak|nautilus|aqua terra|datejust|oyster perpetual|formula 1|6000|integrated/i]
  ];

  function inferStyle(text, tags) {
    for (var i = 0; i < tags.length; i++) {
      var m = /^(?:finder|style):\s*(dress|diver|chrono|pilot|field|sport)$/i.exec(tags[i]);
      if (m) return m[1].toLowerCase();
    }
    for (var j = 0; j < STYLE_WORDS.length; j++) if (STYLE_WORDS[j][1].test(text)) return STYLE_WORDS[j][0];
    return 'dress';
  }

  function inferMovement(text) {
    var t = (text || '').toLowerCase();
    if (/quartz|quarz|electronic|f300|battery/.test(t)) return 'quartz';
    if (/manual|hand|handaufzug|hand-wound|mechanical|cal\. ?684/.test(t) && !/auto/.test(t)) return 'manual';
    if (/auto/.test(t)) return 'automatic';
    return '';
  }

  function num(s) {
    var m = /(\d{2}(?:[.,]\d)?)/.exec(String(s || ''));
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  }

  function stockItems() {
    var el = root.querySelector('[data-bw-finder-stock]');
    if (!el) return [];
    var raw;
    try { raw = JSON.parse(el.textContent); } catch (e) { return []; }
    return raw.filter(function (p) { return p.sold || (p.available && p.price > 0); }).map(function (p) {
      var tags = p.tags || [];
      var text = [p.title, p.type, p.movement, tags.join(' ')].join(' ');
      var dia = num(p.case_size);
      var year = parseInt(p.year, 10) || 0;
      var lady = tags.some(function (t) { return /ladies|lady|damen|women/i.test(t); }) || /ladies|lady/i.test(p.title);
      var shape = /tank|reverso|rectang/i.test(p.title) ? 'tank' : /cushion/i.test(p.title) ? 'cushion' : 'round';
      if (!dia) dia = lady ? 26 : shape === 'tank' ? 29 : 36;
      return {
        id: 'bw-' + p.handle,
        src: p.sold ? 'sold' : 'bw',
        brand: p.vendor,
        model: p.model || p.title,
        ref: p.reference || '',
        style: inferStyle(text, tags),
        movement: inferMovement(p.movement || text) || 'automatic',
        dia: dia,
        l2l: num(p.l2l) || Math.round(dia * (shape === 'tank' ? 1.32 : 1.2) * 10) / 10,
        l2lEstimated: !num(p.l2l),
        thick: num(p.thickness) || 0,
        water: 0,
        era: (year && year < 1990) || tags.some(function (t) { return /vintage/i.test(t); }) ? 'vintage' : 'modern',
        bracelet: null,
        lo: p.sold ? 0 : p.price / 100,
        hi: p.sold ? 0 : p.price / 100,
        dial: '',
        shape: shape,
        lady: lady,
        year: year,
        img: p.image,
        url: p.url,
        boxPapers: p.box_papers || '',
        cut: p.cutout || null
      };
    });
  }

  function marketItems() {
    return (window.BW_FINDER_MARKET || []).map(function (m) {
      return {
        id: m.id, src: 'market', brand: m.brand, model: m.model, ref: m.ref || '',
        style: m.style, movement: m.movement, dia: m.dia, l2l: m.l2l, thick: m.thick || 0,
        water: m.water || 0, era: m.era, bracelet: !!m.bracelet,
        lo: m.price[0], hi: m.price[1], dial: m.dial || 'black', shape: m.shape || 'round', lady: !!m.lady
      };
    });
  }

  var WATCHES = stockItems().concat(marketItems());
  var TOTAL = WATCHES.length;
  var BY_ID = {};
  WATCHES.forEach(function (w) { BY_ID[w.id] = w; });

  /* ------------------------------------------------------------- questions */

  var WRIST = {
    small:  { l2l: [38, 44.5], label: 'Small', sub: 'Under 16 cm' },
    medium: { l2l: [42, 47.5], label: 'Medium', sub: '16 to 17.5 cm' },
    large:  { l2l: [45.5, 50.5], label: 'Large', sub: '17.5 to 19 cm' },
    xl:     { l2l: [48.5, 54], label: 'Extra large', sub: 'Over 19 cm' },
    unsure: { l2l: [41, 51], label: 'Not sure', sub: '' }
  };
  var SIZE_FOR_WRIST = { small: 'small', medium: 'classic', large: 'medium', xl: 'large' };
  var SIZE_RANGE = { small: [0, 36.4], classic: [36.5, 39.4], medium: [39.5, 42.4], large: [42.5, 99] };

  var STEPS = [
    { key: 'wrist', q: 'How big is your wrist?', help: true, cols: 5,
      opts: ['small', 'medium', 'large', 'xl', 'unsure'].map(function (k) { return { v: k, label: WRIST[k].label, sub: WRIST[k].sub }; }) },
    { key: 'style', q: 'Which kind of watch?', multi: true, cols: 6, colsSm: 3, wide: true,
      opts: [
        { v: 'dress', label: 'Dress', sub: 'Slim, clean dial', art: 'dress' },
        { v: 'diver', label: 'Diver', sub: 'Bezel, lume, water', art: 'diver' },
        { v: 'chrono', label: 'Chronograph', sub: 'Stopwatch subdials', art: 'chrono' },
        { v: 'pilot', label: 'Pilot', sub: 'Big legible numerals', art: 'pilot' },
        { v: 'field', label: 'Field', sub: 'Tough and simple', art: 'field' },
        { v: 'sport', label: 'Sports', sub: 'Bracelet, everyday', art: 'sport' }
      ] },
    { key: 'wear', q: 'When will you wear it?', cols: 4,
      opts: [
        { v: 'daily', label: 'Every day', sub: 'One watch, all week' },
        { v: 'office', label: 'Office and occasions', sub: 'Under a shirt cuff' },
        { v: 'active', label: 'Sport and travel', sub: 'Water, knocks, time zones' },
        { v: 'any', label: 'No preference', sub: 'Show everything' }
      ] },
    { key: 'size', q: 'How big should the case be?', cols: 5, recommend: true,
      opts: [
        { v: 'small', label: 'Small', sub: 'Up to 36 mm' },
        { v: 'classic', label: 'Classic', sub: '37 to 39 mm' },
        { v: 'medium', label: 'Medium', sub: '40 to 42 mm' },
        { v: 'large', label: 'Large', sub: '43 mm and up' },
        { v: 'any', label: 'No preference', sub: 'Whatever fits' }
      ] },
    { key: 'movement', q: 'What should drive it?', cols: 4,
      opts: [
        { v: 'automatic', label: 'Automatic', sub: 'Winds on your wrist' },
        { v: 'manual', label: 'Hand-wound', sub: 'Wind it each morning' },
        { v: 'quartz', label: 'Quartz', sub: 'Battery, grab and go' },
        { v: 'any', label: 'No preference', sub: 'Nothing ruled out' }
      ] },
    { key: 'era', q: 'Vintage or modern?', cols: 3,
      opts: [
        { v: 'vintage', label: 'Vintage', sub: 'Made before 1990' },
        { v: 'modern', label: 'Modern', sub: 'Current designs' },
        { v: 'any', label: 'Both', sub: 'Show both' }
      ] },
    { key: 'strap', q: 'Bracelet or strap?', cols: 3,
      opts: [
        { v: 'bracelet', label: 'Metal bracelet', sub: 'Steel or gold links' },
        { v: 'strap', label: 'Strap', sub: 'Leather, rubber, fabric' },
        { v: 'any', label: 'Either', sub: 'Straps can be swapped' }
      ] },
    { key: 'budget', q: 'What is your budget?', budget: true },
    { key: 'done', q: 'Your matches', done: true }
  ];
  var BUDGET_STOPS = [300, 500, 750, 1000, 1500, 2000, 3000, 4000, 5000, 7500, 10000, 15000];

  /* ---------------------------------------------------------------- state */

  var A = {};      // answers
  var step = 0;

  function readHash() {
    A = {};
    var h = location.hash.replace(/^#/, '');
    if (!h) return;
    h.split('&').forEach(function (kv) {
      var p = kv.split('=');
      if (!p[0] || p[1] == null) return;
      var v = decodeURIComponent(p[1]);
      if (p[0] === 'style') A.style = v ? v.split(',') : [];
      else if (p[0] === 'budget') A.budget = v === 'any' ? 'any' : parseInt(v, 10);
      else A[p[0]] = v;
    });
  }
  function writeHash() {
    var parts = [];
    STEPS.forEach(function (s) {
      var v = A[s.key];
      if (v == null || s.done) return;
      parts.push(s.key + '=' + encodeURIComponent(Array.isArray(v) ? v.join(',') : v));
    });
    var h = parts.length ? '#' + parts.join('&') : ' ';
    if (history.replaceState) history.replaceState(null, '', h === ' ' ? location.pathname + location.search : h);
  }
  function firstUnanswered() {
    for (var i = 0; i < STEPS.length; i++) {
      var v = A[STEPS[i].key];
      if (STEPS[i].done) return i;
      if (v == null || (Array.isArray(v) && !v.length)) return i;
    }
    return STEPS.length - 1;
  }

  /* -------------------------------------------------------------- scoring */

  function passes(w, a, skip) {
    if (skip !== 'style' && a.style && a.style.length && a.style.indexOf(w.style) < 0) return false;
    if (skip !== 'movement' && a.movement && a.movement !== 'any' && w.movement !== a.movement) return false;
    if (skip !== 'era' && a.era && a.era !== 'any' && w.era !== a.era) return false;
    if (skip !== 'strap' && a.strap && a.strap !== 'any' && w.bracelet !== null && w.bracelet !== (a.strap === 'bracelet')) return false;
    if (skip !== 'size' && a.size && a.size !== 'any') {
      var r = SIZE_RANGE[a.size];
      if (w.dia < r[0] || w.dia > r[1]) return false;
    }
    if (skip !== 'budget' && typeof a.budget === 'number' && w.lo > a.budget) return false;
    return true;
  }

  // 0..1: how well the lug-to-lug sits on this wrist
  function fit(w, a) {
    var band = WRIST[a.wrist || 'unsure'].l2l;
    var d = w.l2l < band[0] ? band[0] - w.l2l : w.l2l > band[1] ? w.l2l - band[1] : 0;
    var f = Math.max(0, 1 - d * 0.17);
    if (w.lady && (a.wrist === 'large' || a.wrist === 'xl')) f *= 0.5;
    return f;
  }

  function wearScore(w, a) {
    if (!a.wear || a.wear === 'any') return 0.5;
    if (a.wear === 'office') return (w.style === 'dress' ? 1 : w.style === 'sport' || w.style === 'chrono' ? 0.6 : 0.25) * (w.thick && w.thick > 13 ? 0.6 : 1);
    if (a.wear === 'active') return (w.style === 'diver' || w.style === 'field' ? 1 : w.style === 'sport' || w.style === 'pilot' ? 0.75 : w.style === 'chrono' ? 0.55 : 0.1) * (w.water >= 100 ? 1 : 0.8);
    // daily: versatile pieces win
    return w.style === 'sport' || w.style === 'field' ? 1 : w.style === 'diver' || w.style === 'pilot' ? 0.8 : 0.6;
  }

  function score(w, a) {
    var s = fit(w, a) * 0.62 + wearScore(w, a) * 0.22;
    if (typeof a.budget === 'number') {
      var mid = (w.lo + w.hi) / 2;
      s += 0.06 * Math.max(0, 1 - Math.abs(a.budget * 0.75 - mid) / a.budget); // spend most of it, not all
    }
    if (w.src === 'bw') s += 0.12;
    return s;
  }

  var STRONG = 0.68;

  function rank(a) {
    var out = [];
    for (var i = 0; i < WATCHES.length; i++) {
      var w = WATCHES[i];
      if (!passes(w, a)) continue;
      out.push({ w: w, s: score(w, a), f: fit(w, a) });
    }
    out.sort(function (x, y) { return y.s - x.s; });
    return out;
  }
  function strongCount(list) {
    var n = 0;
    for (var i = 0; i < list.length; i++) if (list[i].f >= STRONG) n++;
    return n;
  }
  function countWith(key, val) {
    var a = {};
    for (var k in A) a[k] = A[k];
    a[key] = key === 'style' ? [val] : val;
    var n = 0;
    for (var i = 0; i < WATCHES.length; i++) if (passes(WATCHES[i], a)) n++;
    return n;
  }

  /* ------------------------------------------------------------ the art */

  var DIAL = {
    black: '#141414', white: '#F3F1EC', silver: '#D5D6D8', blue: '#1F3A6B', green: '#25503A',
    cream: '#EDE3CC', grey: '#5E6166', brown: '#5A3B26', champagne: '#D9C29A', salmon: '#E3A98C'
  };
  var STEEL = '#C9CCD1', STEEL_DK = '#8E9399', GOLD = '#D2B26A';

  function light(hex) {
    var n = parseInt(hex.slice(1), 16);
    return ((n >> 16) * 0.299 + ((n >> 8) & 255) * 0.587 + (n & 255) * 0.114) > 140;
  }

  // Top-down watch drawn at true relative scale: 1 svg unit = 1 mm.
  function watchSVG(w, opts) {
    opts = opts || {};
    var dia = w.dia || 38, l2l = w.l2l || dia * 1.2;
    var dial = DIAL[w.dial] || (w.style === 'dress' ? DIAL.silver : DIAL.black);
    var ink = light(dial) ? '#1A1A1A' : '#F2F2F2';
    var metal = w.lady && w.style === 'dress' ? GOLD : STEEL;
    var r = dia / 2, cx = 30, cy = 30;
    var box = opts.box || 60; // viewBox side in mm (fixed so sizes compare)
    var s = [];
    s.push('<svg viewBox="0 0 ' + box + ' ' + box + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + esc(w.brand + ' ' + w.model) + ', ' + dia + ' mm">');
    s.push('<g transform="translate(' + (box / 2 - 30) + ' ' + (box / 2 - 30) + ')">');
    // strap / bracelet
    var sw = Math.max(10, dia * 0.5);
    var strapCol = w.bracelet ? STEEL_DK : (w.style === 'diver' || w.style === 'sport' ? '#1C1C1E' : '#5A3A24');
    // Straps stop inside the 60 mm box so they never run over a label
    var ext = Math.max(3, Math.min(9, (58 - l2l) / 2));
    if (w.bracelet) {
      for (var y = cy - l2l / 2 - ext; y < cy + l2l / 2 + ext - 2.7; y += 3.2) {
        if (Math.abs(y - cy) < r) continue;
        s.push('<rect x="' + (cx - sw / 2) + '" y="' + y.toFixed(1) + '" width="' + sw + '" height="2.7" rx=".6" fill="' + STEEL + '" stroke="' + STEEL_DK + '" stroke-width=".25"/>');
      }
    } else {
      s.push('<rect x="' + (cx - sw / 2) + '" y="' + (cy - l2l / 2 - ext) + '" width="' + sw + '" height="' + (l2l + ext * 2) + '" rx="2.5" fill="' + strapCol + '"/>');
    }
    // lugs
    var lugW = sw + 2.4;
    s.push('<rect x="' + (cx - lugW / 2) + '" y="' + (cy - l2l / 2) + '" width="' + lugW + '" height="' + l2l + '" rx="2" fill="' + metal + '" stroke="' + STEEL_DK + '" stroke-width=".3"/>');
    // case
    if (w.shape === 'tank' || w.shape === 'square') {
      var cw = dia * (w.shape === 'tank' ? 0.78 : 1), ch = w.shape === 'tank' ? Math.min(l2l, dia * 1.2) : dia;
      s.push('<rect x="' + (cx - cw / 2) + '" y="' + (cy - ch / 2) + '" width="' + cw + '" height="' + ch + '" rx="1.6" fill="' + metal + '" stroke="' + STEEL_DK + '" stroke-width=".35"/>');
      s.push('<rect x="' + (cx - cw / 2 + 2.6) + '" y="' + (cy - ch / 2 + 2.6) + '" width="' + (cw - 5.2) + '" height="' + (ch - 5.2) + '" rx=".8" fill="' + dial + '"/>');
      s.push('<rect x="' + (cx + cw / 2 - 0.2) + '" y="' + (cy - 1.6) + '" width="2.4" height="3.2" rx=".8" fill="' + metal + '"/>');
      r = Math.min(cw, ch) / 2 - 2.6;
    } else {
      var rr = w.shape === 'cushion' ? r * 0.32 : r;
      if (w.shape === 'cushion') s.push('<rect x="' + (cx - r) + '" y="' + (cy - r) + '" width="' + dia + '" height="' + dia + '" rx="' + rr + '" fill="' + metal + '" stroke="' + STEEL_DK + '" stroke-width=".35"/>');
      else s.push('<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + metal + '" stroke="' + STEEL_DK + '" stroke-width=".35"/>');
      // crown + chrono pushers
      s.push('<rect x="' + (cx + r - 0.4) + '" y="' + (cy - 1.8) + '" width="2.8" height="3.6" rx=".9" fill="' + metal + '" stroke="' + STEEL_DK + '" stroke-width=".25"/>');
      if (w.style === 'chrono') {
        [-1, 1].forEach(function (k) {
          var ang = k * 0.62, px = cx + Math.cos(ang) * (r + 0.6), py = cy + Math.sin(ang) * (r + 0.6);
          s.push('<rect x="' + (px - 1) + '" y="' + (py - 1.3) + '" width="2.6" height="2.6" rx=".5" fill="' + metal + '" transform="rotate(' + (ang * 57.3) + ' ' + px + ' ' + py + ')"/>');
        });
      }
      var inner = r - (w.style === 'diver' ? r * 0.2 : 1.6);
      if (w.style === 'diver') {
        s.push('<circle cx="' + cx + '" cy="' + cy + '" r="' + (r - 0.9) + '" fill="' + (w.dial === 'blue' ? '#1B2E55' : w.dial === 'green' ? '#1F4430' : '#111') + '"/>');
        for (var t = 0; t < 12; t++) {
          var a0 = t * Math.PI / 6 - Math.PI / 2, rr0 = r - 1.6, rr1 = r - 1.6 - (t === 0 ? 0 : 1.6);
          if (t === 0) s.push('<polygon points="' + (cx) + ',' + (cy - r + 3.9) + ' ' + (cx - 1.4) + ',' + (cy - r + 1.6) + ' ' + (cx + 1.4) + ',' + (cy - r + 1.6) + '" fill="#E9E6DE"/>');
          else s.push('<line x1="' + (cx + Math.cos(a0) * rr0) + '" y1="' + (cy + Math.sin(a0) * rr0) + '" x2="' + (cx + Math.cos(a0) * rr1) + '" y2="' + (cy + Math.sin(a0) * rr1) + '" stroke="#E9E6DE" stroke-width=".5"/>');
        }
      }
      if (w.shape === 'cushion') s.push('<rect x="' + (cx - inner) + '" y="' + (cy - inner) + '" width="' + inner * 2 + '" height="' + inner * 2 + '" rx="' + inner * 0.3 + '" fill="' + dial + '"/>');
      else s.push('<circle cx="' + cx + '" cy="' + cy + '" r="' + inner + '" fill="' + dial + '"/>');
      r = inner;
    }
    // indices
    var big = w.style === 'pilot' || w.style === 'field';
    for (var i = 0; i < 12; i++) {
      var an = i * Math.PI / 6 - Math.PI / 2;
      var o = r * 0.9, n = r * (i % 3 === 0 ? (big ? 0.74 : 0.72) : 0.8);
      if (big && i % 3 === 0) {
        s.push('<text x="' + (cx + Math.cos(an) * r * 0.7) + '" y="' + (cy + Math.sin(an) * r * 0.7 + r * 0.09) + '" font-size="' + (r * 0.26) + '" font-family="Helvetica, Arial, sans-serif" font-weight="700" text-anchor="middle" fill="' + ink + '">' + (i === 0 ? 12 : i) + '</text>');
      } else {
        s.push('<line x1="' + (cx + Math.cos(an) * o) + '" y1="' + (cy + Math.sin(an) * o) + '" x2="' + (cx + Math.cos(an) * n) + '" y2="' + (cy + Math.sin(an) * n) + '" stroke="' + ink + '" stroke-width="' + (i % 3 === 0 ? r * 0.07 : r * 0.04) + '" stroke-linecap="round"/>');
      }
    }
    // chrono subdials
    if (w.style === 'chrono') {
      [[-0.45, 0], [0.45, 0], [0, 0.45]].forEach(function (p) {
        s.push('<circle cx="' + (cx + p[0] * r) + '" cy="' + (cy + p[1] * r) + '" r="' + r * 0.2 + '" fill="none" stroke="' + ink + '" stroke-width="' + r * 0.025 + '" opacity=".75"/>');
      });
    }
    // hands at 10:09
    var hcol = ink;
    var ha = (10 * 30 + 4.5) * Math.PI / 180 - Math.PI / 2, ma = 9 * 6 * Math.PI / 180 - Math.PI / 2;
    s.push('<line x1="' + cx + '" y1="' + cy + '" x2="' + (cx + Math.cos(ha) * r * 0.5) + '" y2="' + (cy + Math.sin(ha) * r * 0.5) + '" stroke="' + hcol + '" stroke-width="' + r * 0.085 + '" stroke-linecap="round"/>');
    s.push('<line x1="' + cx + '" y1="' + cy + '" x2="' + (cx + Math.cos(ma) * r * 0.78) + '" y2="' + (cy + Math.sin(ma) * r * 0.78) + '" stroke="' + hcol + '" stroke-width="' + r * 0.06 + '" stroke-linecap="round"/>');
    if (w.style !== 'dress') s.push('<line x1="' + (cx - Math.cos(ma + 1.9) * r * 0.15) + '" y1="' + (cy - Math.sin(ma + 1.9) * r * 0.15) + '" x2="' + (cx + Math.cos(ma + 1.9) * r * 0.85) + '" y2="' + (cy + Math.sin(ma + 1.9) * r * 0.85) + '" stroke="#C39B54" stroke-width="' + r * 0.022 + '"/>');
    s.push('<circle cx="' + cx + '" cy="' + cy + '" r="' + r * 0.05 + '" fill="' + hcol + '"/>');
    s.push('</g></svg>');
    return s.join('');
  }

  function artHTML(w, opts) {
    // A clean cut-out floats; a photo whose frame cuts the case stays a disc
    if (w.cut) {
      return '<div class="bw-ftile__cut"><img src="' + esc(w.cut) + '" alt="' + esc(w.brand + ' ' + w.model) + '" loading="lazy"></div>';
    }
    if (w.img) {
      return '<div class="bw-ftile__disc"><img src="' + esc(w.img) + '" alt="' + esc(w.brand + ' ' + w.model) + '" loading="lazy" width="236" height="236"></div>';
    }
    return watchSVG(w, opts);
  }

  /* --------------------------------------------------------------- utils */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function chf(n) { return 'CHF ' + Math.round(n).toLocaleString('en-US'); }
  function priceText(w) {
    if (w.src === 'sold') return 'Sold';
    if (w.src === 'bw') return chf(w.lo);
    return chf(w.lo) + ' to ' + chf(w.hi).replace('CHF ', '');
  }
  function title(w) { return w.brand + ' ' + w.model; }
  var STYLE_NAME = { dress: 'Dress', diver: 'Diver', chrono: 'Chronograph', pilot: 'Pilot', field: 'Field', sport: 'Sports' };
  var MOVE_NAME = { automatic: 'Automatic', manual: 'Hand-wound', quartz: 'Quartz' };

  var ICONS = {
    back: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M13 8H3M7 4L3 8l4 4"/></svg>',
    restart: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 8a5.5 5.5 0 1 0 1.6-3.9M2.5 2.5v3h3"/></svg>',
    info: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="8" cy="8" r="6.2"/><path d="M8 7.2v4M8 4.9v.2" stroke-linecap="round"/></svg>',
    close: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 4l8 8M12 4l-8 8"/></svg>'
  };

  /* --------------------------------------------------------------- field */

  var field = root.querySelector('[data-bw-finder-field]');
  var tiles = {};          // id -> element
  var slotOf = {};         // id -> peripheral slot index
  var SLOTS = [];

  function buildSlots() {
    SLOTS = [];
    var cols = 8, rows = 6, seed = 7;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        var x = (c + 0.5) / cols, y = (r + 0.5) / rows;
        x += (rnd() - 0.5) * 0.06; y += (rnd() - 0.5) * 0.08;
        if (x > 0.3 && x < 0.7 && y < 0.62) continue;           // the hero stage
        if (x > 0.2 && x < 0.8 && y > 0.6) continue;            // under the card
        SLOTS.push({ x: x, y: y, s: 0.5 + rnd() * 0.18, d: rnd() * -9 });
      }
    }
  }
  var HERO = [{ x: 0.5, s: 1.1 }, { x: 0.36, s: 1 }, { x: 0.64, s: 1 }];

  // Phones (after shapefinder.cc): the card is a bottom sheet, the best watch
  // sits big at the top, two side by side below it, a few faded ones around.
  // x is a fraction of the width, y a fraction of the stage above the sheet.
  var NARROW_SLOTS = [{ x: 0.1, y: 0.2, s: 0.55 }, { x: 0.9, y: 0.2, s: 0.55 }];
  function isNarrow() { return root.clientWidth < 640; }
  function maxPeripheral() { return isNarrow() ? NARROW_SLOTS.length : SLOTS.length; }

  function renderField(list) {
    var W = field.clientWidth, H = field.clientHeight;
    // A tab opened in the background can boot with no layout yet: every tile
    // would land at x = 0. Skip; the ResizeObserver below re-runs this.
    if (!W || !H) return;
    var cardH = (root.querySelector('.bw-fcard') || {}).offsetHeight || 220;
    var intro = root.querySelector('.bw-finder__intro');
    var top = (intro ? intro.offsetHeight : 0) + 70;
    var bottom = H - cardH - 95;
    // Short screens or a tall card: shrink the stage rather than run under the card
    var heroK = Math.max(0.6, Math.min(1, (bottom - top) / 300));
    if (bottom - top < 120) bottom = top + 120;
    var heroIds = list.slice(0, 3).map(function (x) { return x.w.id; });
    var restIds = list.slice(3, 3 + maxPeripheral()).map(function (x) { return x.w.id; });

    // Not enough matches: fill the edges with dimmed watches so the field never empties
    var dimIds = [];
    if (restIds.length < maxPeripheral()) {
      var seen = {};
      heroIds.concat(restIds).forEach(function (id) { seen[id] = 1; });
      for (var i = 0; i < WATCHES.length && restIds.length + dimIds.length < maxPeripheral(); i++) {
        var id = WATCHES[(i * 37) % WATCHES.length].id;
        if (!seen[id]) { seen[id] = 1; dimIds.push(id); }
      }
    }
    var periph = restIds.concat(dimIds);
    var wanted = {};
    heroIds.concat(periph).forEach(function (id) { wanted[id] = 1; });

    // Keep surviving tiles on their old slot, hand free slots to newcomers
    var used = {};
    periph.forEach(function (id) { if (slotOf[id] != null && slotOf[id] < maxPeripheral()) used[slotOf[id]] = id; });
    var free = [];
    for (var k = 0; k < maxPeripheral(); k++) if (!used[k]) free.push(k);
    periph.forEach(function (id) {
      if (slotOf[id] == null || used[slotOf[id]] !== id) slotOf[id] = free.shift();
    });

    // Retire tiles that left
    Object.keys(tiles).forEach(function (id) {
      if (wanted[id]) return;
      var el = tiles[id];
      el.classList.add('is-out');
      delete tiles[id];
      delete slotOf[id];
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 900);
    });

    function place(id, x, y, sc, hero, dim) {
      var w = BY_ID[id], el = tiles[id];
      if (!el) {
        el = document.createElement('div');
        el.className = 'bw-ftile is-out';
        el.innerHTML = '<div class="bw-ftile__float" style="animation-delay:' + (Math.random() * -9).toFixed(1) + 's"><div class="bw-ftile__art">' + artHTML(w) + '</div></div>' +
          '<div class="bw-ftile__label"><div class="bw-ftile__name">' + esc(title(w)) + '</div></div>';
        el.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + sc * 0.8 + ')';
        field.appendChild(el);
        tiles[id] = el;
        void el.offsetWidth;
      }
      el.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + sc + ')';
      el.classList.toggle('is-hero', hero);
      el.classList.toggle('is-dim', !!dim);
      el.classList.remove('is-out');
    }
    var narrow = isNarrow();
    // Phone stage: from under the eyebrow to the top of the bottom sheet
    var nTop = (intro ? intro.offsetHeight : 0) + 6, nBottom = H - cardH - 6, nStage = Math.max(240, nBottom - nTop);
    heroIds.forEach(function (id, i) {
      var h = HERO[i];
      if (narrow) return place(id, W * [0.5, 0.27, 0.73][i], nTop + nStage * (i === 0 ? 0.24 : 0.66), i === 0 ? 1.08 : 0.98, true);
      place(id, W * h.x, i === 0 ? top + (bottom - top) * 0.12 : top + (bottom - top) * 0.7, h.s * heroK, true);
    });
    var dimSet = {};
    dimIds.forEach(function (id) { dimSet[id] = 1; });
    periph.forEach(function (id) {
      if (narrow) {
        var ns = NARROW_SLOTS[slotOf[id]];
        if (ns) place(id, W * ns.x, nTop + nStage * ns.y, ns.s, false, dimSet[id]);
        return;
      }
      var sl = SLOTS[slotOf[id]];
      if (!sl) return;
      place(id, W * sl.x, H * sl.y, sl.s, false, dimSet[id]);
    });
  }

  /* ---------------------------------------------------------------- card */

  var card = root.querySelector('[data-bw-finder-card]');
  var live = root.querySelector('[data-bw-finder-live]');

  function setCount(list) {
    var strong = strongCount(list);
    var stock = 0;
    for (var i = 0; i < list.length; i++) if (list[i].w.src === 'bw' && list[i].f >= STRONG) stock++;
    if (!Object.keys(A).length) {
      live.innerHTML = '<b>' + TOTAL + '</b> watches. Find the one that fits your wrist.';
      return;
    }
    // Stock only: every watch is ours, so say how many fit, never "0 of 15"
    if (strong) live.innerHTML = '<b>' + strong + '</b> of our ' + TOTAL + ' watches fit your answers' +
      (stock ? ', <b>' + stock + '</b> in stock' : ', all sold so far') + '. The best are in the centre.';
    else if (list.length) live.innerHTML = 'No exact fit right now. The closest are in the centre.';
    else live.innerHTML = 'Nothing matches every answer. Go back and loosen one.';
  }

  function optHTML(s, o, selected, disabled, badge) {
    return '<button type="button" class="bw-fopt" data-v="' + esc(o.v) + '" aria-pressed="' + (selected ? 'true' : 'false') + '"' + (disabled ? ' disabled' : '') + '>' +
      (badge ? '<span class="bw-fopt__badge">Recommended</span>' : '') +
      (o.art ? '<span class="bw-fopt__art" aria-hidden="true">' + watchSVG({ style: o.art, dia: o.art === 'dress' ? 36 : 40, l2l: o.art === 'dress' ? 43 : 48, dial: o.art === 'dress' ? 'silver' : o.art === 'diver' ? 'black' : o.art === 'sport' ? 'blue' : o.art === 'field' ? 'black' : o.art === 'chrono' ? 'white' : 'black', bracelet: o.art === 'sport' || o.art === 'diver', brand: '', model: '' }, { box: 58 }) + '</span>' : '') +
      '<span class="bw-fopt__label">' + esc(o.label) + '</span>' +
      (o.sub ? '<span class="bw-fopt__sub">' + esc(o.sub) + '</span>' : '') +
      '</button>';
  }

  function renderCard() {
    var s = STEPS[step];
    var html = '<div class="bw-fcard__head"><div class="bw-fcard__nav">' +
      '<button type="button" class="bw-ficon" data-act="back" aria-label="Back"' + (step === 0 ? ' hidden' : '') + '>' + ICONS.back + '</button>' +
      '<button type="button" class="bw-ficon" data-act="restart" aria-label="Start again"' + (step === 0 && !Object.keys(A).length ? ' hidden' : '') + '>' + ICONS.restart + '</button>' +
      '</div><h2 class="bw-fcard__q" id="bw-fq">' + esc(s.q) + '</h2><div class="bw-fcard__aside">' +
      (s.help ? '<button type="button" class="bw-ficon" data-act="help" aria-label="How to measure your wrist" aria-expanded="false">' + ICONS.info + '</button>' : '') +
      (s.budget ? '<span data-budget-count></span>' : '') +
      '</div></div>';

    if (s.help) html += '<p class="bw-fhelp" hidden data-help>Wrap a strip of paper around your wrist just above the bone, mark where it meets, and measure it flat. What matters is the lug-to-lug: the watch should end before the edges of the top of your wrist.</p>';

    if (s.done) {
      html += '<button type="button" class="bw-fbtn" data-act="results">View matches</button>';
    } else if (s.budget) {
      var idx = typeof A.budget === 'number' ? Math.max(0, BUDGET_STOPS.indexOf(A.budget)) : 6;
      html += '<div class="bw-fbudget"><div class="bw-fbudget__track">' +
        '<div class="bw-fbudget__val" data-budget-val></div>' +
        '<input type="range" min="0" max="' + (BUDGET_STOPS.length - 1) + '" step="1" value="' + idx + '" aria-label="Budget" data-budget>' +
        '<div class="bw-fbudget__ticks"><span>CHF 300</span><span>1,500</span><span>5,000</span><span>15,000</span></div></div>' +
        optHTML(s, { v: 'any', label: 'No limit' }, A.budget === 'any', false, false) + '</div>' +
        '<button type="button" class="bw-fbtn" data-act="next">Continue</button>';
    } else {
      var cur = A[s.key];
      var rec = s.recommend && A.wrist && SIZE_FOR_WRIST[A.wrist];
      html += '<div class="bw-fopts" role="group" aria-labelledby="bw-fq" style="--cols:' + s.cols + ';--cols-sm:' + (s.colsSm || 2) + '">';
      s.opts.forEach(function (o) {
        var sel = s.multi ? (cur || []).indexOf(o.v) >= 0 : cur === o.v;
        var dis = o.v !== 'any' && s.key !== 'wrist' && s.key !== 'wear' && countWith(s.key, o.v) === 0;
        html += optHTML(s, o, sel, dis && !sel, rec === o.v);
      });
      html += '</div>';
      if (s.multi) html += '<button type="button" class="bw-fbtn" data-act="next"' + ((cur || []).length ? '' : ' hidden') + '>Continue</button>';
    }
    card.innerHTML = html;
    card.classList.toggle('is-wide', !!s.wide);
    if (s.budget) syncBudget();
  }

  function syncBudget() {
    var inp = card.querySelector('[data-budget]');
    var val = card.querySelector('[data-budget-val]');
    var cnt = card.querySelector('[data-budget-count]');
    var b = A.budget === 'any' ? 'any' : BUDGET_STOPS[+inp.value];
    val.textContent = b === 'any' ? 'No limit' : 'Up to ' + chf(b);
    var a = {};
    for (var k in A) a[k] = A[k];
    a.budget = b;
    var n = 0;
    for (var i = 0; i < WATCHES.length; i++) if (passes(WATCHES[i], a)) n++;
    cnt.innerHTML = '<b>' + n + '</b> watches';
  }

  function update() {
    var list = rank(A);
    setCount(list);
    renderField(list);
    writeHash();
  }

  // A question earns its place only if it can narrow the list. With a small
  // stock some never do (no product records bracelet vs strap), so skip them.
  function useful(i) {
    var s = STEPS[i];
    if (s.done || s.key === 'wrist' || s.key === 'wear') return true;
    if (s.budget) {
      var lo = Infinity, hi = 0;
      WATCHES.forEach(function (w) { lo = Math.min(lo, w.lo); hi = Math.max(hi, w.lo); });
      return hi > lo * 1.5;
    }
    var base = 0;
    for (var j = 0; j < WATCHES.length; j++) if (passes(WATCHES[j], A, s.key)) base++;
    var live = 0, narrows = false;
    s.opts.forEach(function (o) {
      if (o.v === 'any') return;
      var n = countWith(s.key, o.v);
      if (n > 0) live++;
      if (n > 0 && n < base) narrows = true;
    });
    return live >= 2 && narrows;
  }

  function go(i, dir) {
    dir = dir || 1;
    i = Math.max(0, Math.min(STEPS.length - 1, i));
    while (!useful(i) && i + dir >= 0 && i + dir < STEPS.length) {
      if (!STEPS[i].done && A[STEPS[i].key] == null) A[STEPS[i].key] = STEPS[i].budget ? 'any' : STEPS[i].multi ? [] : 'any';
      i += dir;
    }
    step = i;
    renderCard();
    update();
  }

  card.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || b.disabled) return;
    var s = STEPS[step];
    var act = b.getAttribute('data-act');
    if (act === 'back') return go(step - 1, -1);
    if (act === 'restart') { A = {}; return go(0); }
    if (act === 'help') {
      var h = card.querySelector('[data-help]');
      h.hidden = !h.hidden;
      b.setAttribute('aria-expanded', String(!h.hidden));
      return;
    }
    if (act === 'results') return openResults();
    if (act === 'next') {
      if (s.budget && A.budget == null) A.budget = BUDGET_STOPS[+card.querySelector('[data-budget]').value];
      return go(step + 1);
    }
    var v = b.getAttribute('data-v');
    if (v == null) return;
    if (s.budget) { A.budget = A.budget === 'any' ? BUDGET_STOPS[+card.querySelector('[data-budget]').value] : 'any'; renderCard(); return update(); }
    if (s.multi) {
      var arr = (A[s.key] || []).slice();
      var at = arr.indexOf(v);
      if (at >= 0) arr.splice(at, 1); else arr.push(v);
      A[s.key] = arr;
      renderCard();
      return update();
    }
    A[s.key] = v;
    // A recommended size follows the wrist unless the buyer already chose one
    renderCard();
    update();
    setTimeout(function () { if (STEPS[step] === s) go(step + 1); }, 260);
  });

  card.addEventListener('input', function (e) {
    if (!e.target.matches('[data-budget]')) return;
    A.budget = BUDGET_STOPS[+e.target.value];
    var none = card.querySelector('.bw-fbudget .bw-fopt');
    if (none) none.setAttribute('aria-pressed', 'false');
    syncBudget();
    update();
  });

  /* ------------------------------------------------------------- results */

  var overlay = root.querySelector('[data-bw-finder-results]');
  // The section isolates its stacking context, which trapped the overlay
  // under the sticky site header. Lift it to <body>.
  document.body.appendChild(overlay);
  var lastFocus = null;
  var current = null;
  var resultList = [];

  function fitWords(w) {
    var band = WRIST[A.wrist || 'unsure'].l2l;
    if (w.l2l < band[0] - 1.5) return ['Discreet', 'is-warn'];
    if (w.l2l > band[1] + 1.5) return ['Bold', 'is-warn'];
    return ['Ideal', 'is-good'];
  }

  function whyText(w) {
    var band = WRIST[A.wrist || 'unsure'].l2l;
    var bits = [];
    if (A.wrist && A.wrist !== 'unsure') {
      var mid = (band[0] + band[1]) / 2;
      bits.push('At ' + w.l2l + ' mm lug to lug it ' + (Math.abs(w.l2l - mid) <= (band[1] - band[0]) / 2 ? 'sits inside the ' + band[0] + ' to ' + band[1] + ' mm range that suits your wrist' : w.l2l < mid ? 'wears smaller than the ' + band[0] + ' to ' + band[1] + ' mm range for your wrist, so it reads as understated' : 'runs past the ' + band[0] + ' to ' + band[1] + ' mm range for your wrist, so expect real presence') + '.');
    }
    if (w.l2lEstimated) bits.push('Lug to lug is estimated from the case size; ask us for the exact measurement.');
    if (w.src === 'bw') bits.push('This exact piece is in our stock, checked by us before it ships.');
    else if (w.src === 'sold') bits.push('This piece has already sold. Tell us and we will hunt one like it for you.');
    else bits.push('Not in our stock right now. Tell us and we will hunt a good example for you.');
    return bits.join(' ');
  }

  function renderDetail(w) {
    current = w;
    var fw = fitWords(w);
    var main = overlay.querySelector('[data-res-main]');
    var specs = [
      ['Reference', w.ref],
      ['Style', STYLE_NAME[w.style]],
      ['Movement', MOVE_NAME[w.movement]],
      ['Thickness', w.thick ? w.thick + ' mm' : ''],
      ['Water resistance', w.water ? w.water + ' m' : ''],
      ['Era', w.year ? w.year : w.era === 'vintage' ? 'Vintage' : 'Modern'],
      ['On', w.bracelet == null ? '' : w.bracelet ? 'Metal bracelet' : 'Strap'],
      ['Box and papers', w.boxPapers]
    ].filter(function (r) { return r[1]; });
    var q = encodeURIComponent((w.brand + ' ' + w.model + ' ' + (w.ref || '')).trim());
    var shops = '';
    var huntUrl = esc(root.getAttribute('data-hunt-url') || '/pages/contact');
    if (w.src === 'bw') {
      shops += '<a class="bw-fshop bw-fshop--primary" href="' + esc(w.url) + '">View this watch</a>';
    } else if (w.src === 'sold') {
      shops += '<a class="bw-fshop bw-fshop--primary" href="' + huntUrl + '">Ask us to find one like it</a>' +
        '<a class="bw-fshop" href="' + esc(w.url) + '">See the sold piece</a>';
    } else {
      shops += '<a class="bw-fshop bw-fshop--primary" href="' + esc(root.getAttribute('data-hunt-url') || '/pages/contact') + '">Ask us to hunt one</a>' +
        '<a class="bw-fshop" href="https://www.chrono24.ch/search/index.htm?query=' + q + '" target="_blank" rel="noopener">Search Chrono24</a>' +
        '<a class="bw-fshop" href="https://www.ricardo.ch/de/s/' + q + '" target="_blank" rel="noopener">Search Ricardo</a>';
    }
    main.innerHTML =
      '<button type="button" class="bw-ficon bw-fres__close" data-act="close" aria-label="Close">' + ICONS.close + '</button>' +
      '<div class="bw-fres__stage">' + (w.img ? '<img src="' + esc(w.img.replace(/width=\d+/, 'width=900')) + '" alt="' + esc(title(w)) + '">' : '<div>' + watchSVG(w, { box: 70 }) + '<p class="bw-fres__scale">Drawn to scale: ' + w.dia + ' mm case, ' + w.l2l + ' mm lug to lug</p></div>') + '</div>' +
      '<div class="bw-fres__info">' +
      '<p class="bw-fres__brand">' + esc(w.brand) + '</p>' +
      '<h3 class="bw-fres__name">' + esc(w.model) + '</h3>' +
      '<p class="bw-fres__price">' + esc(priceText(w)) + (w.src === 'market' ? '<small>Typical pre-owned price</small>' : '') + '</p>' +
      (w.src === 'bw' ? '<span class="bw-fres__stock">In stock</span>' : w.src === 'sold' ? '<span class="bw-fres__stock bw-fres__stock--sold">Sold</span>' : '') +
      '<div class="bw-fres__tiles"><div class="bw-fres__tile"><span>Case</span><b>' + w.dia + ' mm</b></div>' +
      '<div class="bw-fres__tile"><span>Fit on your wrist</span><b class="' + fw[1] + '">' + fw[0] + '</b></div></div>' +
      '<dl class="bw-fres__specs">' + specs.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>' +
      '<p class="bw-fres__why">' + esc(whyText(w)) + '</p>' +
      '<div class="bw-fres__shops">' + shops + '</div></div>';
    overlay.querySelectorAll('.bw-fitem').forEach(function (it) { it.setAttribute('aria-current', it.getAttribute('data-id') === w.id ? 'true' : 'false'); });
  }

  function openResults() {
    resultList = rank(A).filter(function (x) { return x.f >= STRONG; }).slice(0, 60);
    var exact = resultList.length > 0;
    if (!exact) resultList = rank(A).slice(0, 30);
    var hunt = '<a href="' + esc(root.getAttribute('data-hunt-url') || '/pages/contact') + '" style="color:var(--bw-brass-lt)">ask us to hunt one</a>';
    var list = overlay.querySelector('[data-res-list]');
    if (!resultList.length) {
      list.innerHTML = '<p class="bw-fres__listhead">Nothing in stock matches every answer. Go back and loosen one, or ' + hunt + '.</p>';
    } else {
      list.innerHTML = '<p class="bw-fres__listhead">' + (exact ? '<b>' + resultList.length + '</b> fit you, in stock first' : 'No exact fit right now. These are the closest, or ' + hunt + '.') + '</p>' + resultList.map(function (x, i) {
        var w = x.w;
        return '<button type="button" class="bw-fitem" data-id="' + esc(w.id) + '">' +
          '<span class="bw-fitem__art">' + (w.cut ? '<img class="is-cut" src="' + esc(w.cut) + '" alt="" loading="lazy">' : w.img ? '<img src="' + esc(w.img) + '" alt="" loading="lazy">' : watchSVG(w, { box: 64 })) + '</span>' +
          '<span><span class="bw-fitem__name" style="display:block">' + esc(title(w)) + '</span><span class="bw-fitem__meta">' + w.dia + ' mm · ' + esc(priceText(w)) + '</span></span>' +
          (w.src === 'bw' ? '<span class="bw-fitem__tag bw-fitem__tag--stock">In stock</span>' : w.src === 'sold' ? '<span class="bw-fitem__tag">Sold</span>' : i === 0 ? '<span class="bw-fitem__tag">Best match</span>' : '<span></span>') +
          '</button>';
      }).join('');
    }
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    if (resultList.length) renderDetail(resultList[0].w);
    else overlay.querySelector('[data-res-main]').innerHTML = '<button type="button" class="bw-ficon bw-fres__close" data-act="close" aria-label="Close">' + ICONS.close + '</button>';
    var c = overlay.querySelector('[data-act="close"]');
    if (c) c.focus();
  }

  function closeResults() {
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus();
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) return closeResults();
    var b = e.target.closest('button');
    if (!b) return;
    if (b.getAttribute('data-act') === 'close') return closeResults();
    var id = b.getAttribute('data-id');
    if (id && BY_ID[id]) {
      renderDetail(BY_ID[id]);
      if (window.innerWidth <= 860) { overlay.querySelector('[data-res-main]').scrollTop = 0; overlay.querySelector('.bw-fres').scrollTop = 0; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeResults();
  });

  /* ---------------------------------------------------------------- boot */

  buildSlots();
  readHash();
  step = firstUnanswered();
  while (!useful(step) && step < STEPS.length - 1) step++;
  root.classList.add('is-ready');
  renderCard();
  update();

  var rt;
  function relayout() {
    clearTimeout(rt);
    rt = setTimeout(function () { renderField(rank(A)); }, 120);
  }
  if (window.ResizeObserver) new ResizeObserver(relayout).observe(root);
  else window.addEventListener('resize', relayout);
  // A page opened in a background tab can lay out against a stale size, and
  // hidden tabs throttle the observer's timer. Re-run once it is shown.
  document.addEventListener('visibilitychange', function () { if (!document.hidden) relayout(); });
})();
